import React from 'react';
import { arrayOf, bool, func, object, oneOfType, shape, string } from 'prop-types';

import Frequency from '../Frequency';
import ResponseData from '../ResponseData';
import CardSelect from '../CardSelect';
import Events from '../Events';
import { InputField, Select } from '../../../../../../../components';

const FormField = (props) => {
  const {
    children,
    handleChange,
    handleBlur,
    inputName,
    inputType,
    inputValues,
    inputPlaceholder,
    errorMessage,
    disabled,
  } = props;
  const handleInputChange = (event) => {
    const {
      target: {
        name, value,
      },
    } = event;

    handleChange({
      key: name,
      value,
    });
  };

  switch (inputType) {
    case 'permissions':
      return (
        <ResponseData
          inputValues={inputValues || []}
          inputName={inputName}
          handleChange={handleChange}
        >
          {children}
        </ResponseData>
      );
    case 'events':
      return (
        <Events
          inputValues={inputValues || []}
          inputName={inputName}
          handleChange={handleChange}
          disabled={disabled}
        >
          {children}
        </Events>
      );
    case 'frequency':
      return (
        <Frequency
          inputValues={inputValues}
          inputName={inputName}
          handleChange={handleChange}
          disabled={disabled}
        >
          {children}
        </Frequency>
      );
    case 'dropdown':
      return (
        <Select
          id={`${inputName}-select`}
          name={inputName}
          value={inputValues}
          onChange={handleInputChange}
          options={children.slice(1).map(({ name, text }) => ({
            value: name,
            label: text,
          }))}
          disabled={disabled}
          selectStyles={{ width: '260px' }}
          placeholderOptionLabel={children[0].text}
        />
      );
    case 'cardSelect':
      return (
        <CardSelect
          inputName={inputName}
          inputValue={inputValues}
          handleChange={handleInputChange}
          disabled={disabled}
        >
          {children}
        </CardSelect>
      );
    default:
      return (
        <InputField
          error={Boolean(errorMessage)}
          inputName={inputName}
          handleChange={handleInputChange}
          handleBlur={() => handleBlur(inputName)}
          inputValues={inputValues || ''}
          inputPlaceholder={inputPlaceholder || ''}
          fullWidth
          errorMessage={errorMessage}
        />
      );
  }
};

export default FormField;

FormField.propTypes = {
  handleChange: func.isRequired,
  handleBlur: func.isRequired,
  children: arrayOf(shape({
    name: string,
    text: string,
    type: string,
    path: string,
    children: arrayOf(shape({
      name: string,
      text: string,
    })),
  })),
  inputName: string,
  inputType: string,
  inputValues: oneOfType([string, object, arrayOf(string)]),
  inputPlaceholder: string,
  errorMessage: string.isRequired,
  disabled: bool,
};

FormField.defaultProps = {
  children: [],
  inputName: '',
  inputType: '',
  inputValues: '',
  inputPlaceholder: '',
  disabled: false,
};
